import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ThumbsDown = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17.252 13.25h2.998a1 1 0 0 0 1-1v-7.5a1 1 0 0 0-1-1h-2.998m0 0V13l-3.968 7.708c-.172.333-.52.542-.895.542a2 2 0 0 1-1.975-2.308l.575-3.692H5.75a3 3 0 0 1-2.964-3.451l.836-5.5A3 3 0 0 1 6.586 3.75z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.002 4.5v8h2.248a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25zm-.421 9.5h2.669A1.75 1.75 0 0 0 22 12.25v-7.5A1.75 1.75 0 0 0 20.25 3H6.586A3.75 3.75 0 0 0 2.88 6.186l-.837 5.5A3.75 3.75 0 0 0 5.75 16h4.364l-.44 2.826A2.75 2.75 0 0 0 12.389 22c.65 0 1.26-.362 1.561-.949z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
